import { Configuration } from 'src/app/shared/models/sys/configuration';

export const environment: Configuration = {
  url: 'https://dataviz.metiers-btp.fr',
  api: 'https://www.metiers-btp.fr/wp-json/opmq-dataviz/v1',
  matomo: 'https://matomo.constructys.fr/',
  matomoSiteId: 'olkEPKN8MNLwv83',
};
